<div class="sir-radio-group-label sir-text-style-title-xs-default">
    {{ label }}
</div>
<div class="sir-radio-options">
    @for (opt of options; track $index) {
        <div class="sir-radio-option">
            <input
                type="radio"
                [name]="name"
                [id]="ids[$index]"
                [value]="opt.value"
                [attr.checked]="opt.checked ? 'checked' : null"
                [attr.data-identifier]="identifier"
                (change)="onChange(opt.value)"
                (input)="onChange(opt.value)"
                (blur)="onTouched()"
                [ngClass]="{ 'is-invalid': (valid$ | async) === false }" />
            <sirius-label
                [for]="ids[$index]"
                textStyle="system"
                textStyleSize="l"
                [ngClass]="{ 'is-disabled': control.disabled }">
                {{ opt.text }}
            </sirius-label>
        </div>
    }
</div>
